import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";
import "./style.scss";
import langIcon from "../../assets/icons/lang_icon.svg";
import ArrowUp from "../../assets/icons/short-arrow-up.svg";
import ArrowDown from "../../assets/icons/short-arrow-down.svg";

const MobileAppSelectLang = () => {
  const [currLang, setCurrLang] = useState({ value: "", label: "" });
  const { i18n } = useTranslation();

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {/*<BaseIcon*/}
        {/*  name="lang_arrow"*/}
        {/*  iconWrapperStyle="lang-arrow-wrapper"*/}
        {/*  className={"lang-arrow-icon"}*/}
        {/*/>*/}
        <img src={langIcon} style={{ width: 20, height: 20 }} alt="" />
      </components.DropdownIndicator>
    );
  };
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <img src={ArrowUp} alt="" style={{ width: 14, height: 14, marginBottom: "-2px" }} />
        <img src={ArrowDown} alt="" style={{ width: 14, height: 14, marginTop: "-2px" }} />
      </components.SingleValue>
    );
  };
  const changeLanguage = async (language) => {
    await i18n.changeLanguage(language);
  };
  const onLangChange = async (option) => {
    setCurrLang(option);
    await changeLanguage(option.value);
  };

  useEffect(() => {
    setCurrLang({ value: i18n.language, label: i18n.language?.toUpperCase() });
  }, [i18n.language]);

  const options = [
    { value: "ru", label: "RU" },
    { value: "en", label: "EN" },
  ];

  const fontStyles = {
    fontFamily: "Inter, sans-serif",
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "21.78px",
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      border: "none",
      color: state.isSelected
        ? "var(--palette-button-mobile-app)"
        : "var(--palette-text)",
      padding: 20,
      backgroundColor: "transparent !important",
      cursor: "pointer",
      ...fontStyles,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "var(--palette-button-mobile-app)",
      fontFamily: "Inter, sans-serif",
      ...fontStyles,
      display: "flex",
      flexDirection: "column",
    }),
    menu: (provided, state) => ({
      ...provided,
      border: "none",
      backgroundColor: "var(--palette-main-background)",
    }),
    indicatorSeparator: (provided, state) => ({
      display: "none",
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      color: "var(--palette-button-mobile-app)",
      cursor: "pointer",
      minHeight: 0,
      display: "flex",
      flexDirection: "row-reverse",
      // item 11: разносим глобус и стрелки, чтобы значки не слипались в один
      gap: "8px",
    }),
    // input: (provided, state) => ({
    //   display: "none",
    // }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: 0,
    }),
    placeholder: () => ({
      display: "none",
    }),
  };

  return (
    <div>
      <Select
        isSearchable={false}
        options={options}
        styles={customStyles}
        onChange={onLangChange}
        value={currLang}
        components={{ DropdownIndicator, SingleValue }}
      />
    </div>
  );
};

export default MobileAppSelectLang;
